export type Translations = Record<string, Record<string, string>>

export const translations: Translations = {
  type: {
    software: 'Software',
    connectivity: 'Conectividade',
    hardware: 'Hardware'
  },
  subtype: {
    Claro: 'Claro',
    Vivo: 'Vivo',
    Tim: 'Tim',
    Algar: 'Algar',
    Arqia: 'Arqia',
    s4g: 'Softruck S4G',
    's4g mini': 'Softruck S4G Mini',
    sgo: 'SGo'
  }
}
